import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { VisionSection } from './components/VisionSection';
import { BeforeAfter } from './components/BeforeAfter';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { ImplementationPlan } from './components/ImplementationPlan';
import { Audience } from './components/Audience';
import { NotInside } from './components/NotInside';
import { Testimonials } from './components/Testimonials';
import { AuthorSection } from './components/AuthorSection';
import { ImagineSection } from './components/ImagineSection';
import { Faq } from './components/Faq';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ii4su47vuwpm">
      <MetaPixel data-id="element-1" data-mp="3mjg9hk8s47lo" />
      <Hero data-id="element-2" data-mp="3rc9f0ac2njyt" />
      <main data-id="element-3" data-mp="3rcj8i7wbs999">
        <StorySection data-id="element-4" data-mp="3rbzmog3k10py" />
        <VisionSection data-id="element-5" data-mp="3rdkh85pvcjnt" />
        <BeforeAfter data-id="element-6" data-mp="3recdzjv7cnfo" />
        <Volumes data-id="element-7" data-mp="5yhupa6n3cr" />
        <Bonuses data-id="element-8" data-mp="6hq1ea16ddl" />
        <Offer data-id="element-9" data-mp="4wwnrzgd0hb" />
        <ImplementationPlan data-id="element-10" data-mp="5ggje8nxyxz" />
        <Audience data-id="element-11" data-mp="7st1bvnjh3n" />
        <NotInside data-id="element-12" data-mp="2zld259q0hfbj" />
        <Testimonials data-id="element-13" data-mp="2zlv3gkrj6jqb" />
        <AuthorSection data-id="element-14" data-mp="2zmo4d53t6f0j" />
        <ImagineSection data-id="element-15" data-mp="2zn678kkz7rhf" />
        <Faq data-id="element-16" data-mp="33mf0loc3tncg" />
        <ClosingSection data-id="element-17" data-mp="33lwyib2rgewm" />
      </main>
      <Footer data-id="element-18" data-mp="33mymfg4vkvvr" />
      <FloatingCta data-id="element-19" data-mp="33orla998ybt7" />
      <PurchasePopup data-id="element-20" data-mp="38m1g64fenfof" />
    </div>;
}